import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import {
  ActiveModeCommands,
  Feature,
  FeatureCommands,
  FeatureNames,
  IsStringValueProperty,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';

import { HeatingCircuitIgnoredModalService } from '../heating-circuit-ignored-modal/heating-circuit-ignored-modal.service';

@Component({
  selector: 'app-circuit-operating-mode-panel',
  templateUrl: './circuit-operating-mode-panel.component.html',
  styleUrls: ['./circuit-operating-mode-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircuitOperatingModePanelComponent implements OnInit {
  readonly featureCommands = FeatureCommands;

  operatingModesActive$: Observable<Feature<IsStringValueProperty, ActiveModeCommands>>;

  @Input() circuitId: string;

  constructor(
    private gtmService: GTMService,
    private heatingCircuitIgnoredModalService: HeatingCircuitIgnoredModalService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.operatingModesActive$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      IsStringValueProperty,
      ActiveModeCommands
    >(FeatureNames.circuitActiveMode(this.circuitId));
  }

  onOptionChange(option: { value: string }): void {
    const isOperatingModeChanged = option.value === 'dhw' || option.value === 'standby';
    if (isOperatingModeChanged) {
      this.heatingCircuitIgnoredModalService
        .showModalWhenSrcIsActive(isOperatingModeChanged)
        .pipe(take(1))
        .subscribe(() => {
          this.installationFeaturesStore.updateFeature(
            FeatureNames.circuitActiveMode(this.circuitId),
            option.value,
            'value',
            'mode',
            'setMode'
          );
        });
    } else {
      this.installationFeaturesStore.updateFeature(
        FeatureNames.circuitActiveMode(this.circuitId),
        option.value,
        'value',
        'mode',
        'setMode'
      );
    }
  }

  trackCircuitOperatingMode(): void {
    this.gtmService.track('onSelect', 'Heating circuit`s operating mode', 'operatingMode');
  }
}
